/**
 * Shared category color/gradient definitions
 */

export const CATEGORY_COLORS: Record<string, { pill: string; gradient: string; color: string }> = {
  social:          { pill: 'bg-[#0088CC]/20 text-[#0088CC]', gradient: 'from-[#0088CC]/10 to-[#0088CC]/5', color: '#0088CC' },
  trading:         { pill: 'bg-[#22C55E]/20 text-[#22C55E]', gradient: 'from-[#22C55E]/10 to-[#22C55E]/5', color: '#22C55E' },
  defi:            { pill: 'bg-[#22C55E]/20 text-[#22C55E]', gradient: 'from-[#22C55E]/10 to-[#22C55E]/5', color: '#22C55E' },
  infrastructure:  { pill: 'bg-[#F97316]/20 text-[#F97316]', gradient: 'from-[#F97316]/10 to-[#F97316]/5', color: '#F97316' },
  tools:           { pill: 'bg-[#F97316]/20 text-[#F97316]', gradient: 'from-[#F97316]/10 to-[#F97316]/5', color: '#F97316' },
  creative:        { pill: 'bg-[#EC4899]/20 text-[#EC4899]', gradient: 'from-[#EC4899]/10 to-[#EC4899]/5', color: '#EC4899' },
  games:           { pill: 'bg-[#A855F7]/20 text-[#A855F7]', gradient: 'from-[#A855F7]/10 to-[#A855F7]/5', color: '#A855F7' },
  gaming:          { pill: 'bg-[#A855F7]/20 text-[#A855F7]', gradient: 'from-[#A855F7]/10 to-[#A855F7]/5', color: '#A855F7' },
  entertainment:   { pill: 'bg-[#A855F7]/20 text-[#A855F7]', gradient: 'from-[#A855F7]/10 to-[#A855F7]/5', color: '#A855F7' },
  ai:              { pill: 'bg-[#06B6D4]/20 text-[#06B6D4]', gradient: 'from-[#06B6D4]/10 to-[#06B6D4]/5', color: '#06B6D4' },
  nft:             { pill: 'bg-[#EAB308]/20 text-[#EAB308]', gradient: 'from-[#EAB308]/10 to-[#EAB308]/5', color: '#EAB308' },
  'virtual-worlds':{ pill: 'bg-[#06B6D4]/20 text-[#06B6D4]', gradient: 'from-[#06B6D4]/10 to-[#06B6D4]/5', color: '#06B6D4' },
  'work-markets':  { pill: 'bg-[#EAB308]/20 text-[#EAB308]', gradient: 'from-[#EAB308]/10 to-[#EAB308]/5', color: '#EAB308' },
  relationships:   { pill: 'bg-[#EF4444]/20 text-[#EF4444]', gradient: 'from-[#EF4444]/10 to-[#EF4444]/5', color: '#EF4444' },
};

export const CATEGORY_LABELS: Record<string, string> = {
  social: 'Social',
  trading: 'Trading',
  defi: 'DeFi',
  infrastructure: 'Infrastructure',
  tools: 'Tools',
  creative: 'Creative',
  games: 'Games',
  gaming: 'Gaming',
  entertainment: 'Entertainment',
  ai: 'AI',
  nft: 'NFT',
  'virtual-worlds': 'Virtual Worlds',
  'work-markets': 'Work & Markets',
  relationships: 'Relationships',
};

const DEFAULT_CAT = { pill: 'bg-[#6B7280]/20 text-[#6B7280]', gradient: 'from-[#6B7280]/10 to-[#6B7280]/5', color: '#6B7280' };

export function getCategoryStyle(category: string) {
  return CATEGORY_COLORS[category] || DEFAULT_CAT;
}

export function getCategoryLabel(category: string) {
  return CATEGORY_LABELS[category] || category;
}
